import TokenAvatar from '@components/TokenAvatar'
import { ListGroup, ListRow, cn } from '@ui'
import React from 'react'

export interface BalanceRowProps {
  logo?: string
  title: string
  subtitle?: string
  value?: string
  valueChange?: number | null
  onPress?: () => void
  rightElement?: React.ReactNode
  avatar?: React.ReactNode
}

/** A standalone balance card: avatar, title/subtitle, value with change % in success/danger. */
const BalanceRow = ({
  logo,
  title,
  subtitle,
  value,
  valueChange,
  onPress,
  rightElement,
  avatar,
}: BalanceRowProps) => (
  <ListGroup className="my-1.5">
    <ListRow
      onClick={onPress}
      leading={avatar || <TokenAvatar size={40} logo={logo} />}
      primary={title}
      secondary={subtitle ? <span className="tabular">{subtitle}</span> : undefined}
      trailing={
        rightElement ? (
          <div>{rightElement}</div>
        ) : (
          <span className="flex flex-col items-end gap-0.5">
            <span className="tabular text-[15px] leading-[1.3] font-semibold text-fg">{value}</span>
            {typeof valueChange === 'number' && (
              <span
                className={cn(
                  'tabular text-[13px] leading-[1.4]',
                  (valueChange || 0) > 0 ? 'text-success' : 'text-danger'
                )}
              >
                {`${valueChange?.toFixed(2)}%`}
              </span>
            )}
          </span>
        )
      }
    />
  </ListGroup>
)

export default BalanceRow
